export default __webpack_public_path__ + "static/media/img2.99a2093a.png";